import Grid, { GridProps as MuiGridProps } from '@mui/material/Grid';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import React, { Fragment, memo } from 'react';
import { isPlaceholder } from '../core/utils';
import AvatarPlaceholder, { DogAvatarPlaceholder } from './AvatarPlaceholder';
import SmartAvatar, { ISmartAvatar } from './SmartAvatar';
import SmartImage, { ISmartImage } from './SmartImage';

const bubbleBefore = {
  content: '\"\\00a0\"',
  display: 'block',
  height: 16,
  position: 'absolute',
  top: 11,
  transform: 'rotate(29deg) skew( -35deg)',
  width: 20
};
const bubble = {
  maxWidth: 'calc(100% - 64px)',
  backgroundColor: '#F2F2F2',
  borderRadius: '10px',
  boxShadow: '0 0 6px #b2b2b2',
  display: 'block',
  padding: '10px 18px',
  position: 'relative',
  verticalAlign: 'top',
  color: 'white',
  wordWrap: 'break-word',
  whiteSpace: 'pre-line'
} as any;

const bubble1 = {
  ...bubble,
  backgroundColor: (theme: Theme) => theme.palette.primary.main,
  '&::before': {
    ...bubbleBefore,
    boxShadow: '-2px 2px 2px 0 rgb(178 178 178 / 40%)',
    left: -9,
    backgroundColor: (theme: Theme) => theme.palette.primary.main
  }
};

const bubble2 = {
  ...bubble,
  backgroundColor: (theme: Theme) => theme.palette.primary.light,
  color: (theme: Theme) => theme.palette.primary.contrastText,
  '&::before': {
    ...bubbleBefore,
    boxShadow: '2px -2px 2px 0 rgb(178 178 178 / 40%)',
    right: -9,
    backgroundColor: (theme: Theme) => theme.palette.primary.light
  }
};


export interface IChatBubble {
  direction: 'right' | 'left';
  avatar?: ISmartAvatar;
  body: string;
  thumbnail?: ISmartImage;
  date?: string;
  phone?: string;
  GridProps?: MuiGridProps;
  dog?: boolean;
}

const rightStyles = {
  '& > :not(:last-child)': {
    marginLeft: 6
  }
};

const leftStyles = {
  '& > :not(:last-child)': {
    marginRight: 6
  }
};


function ChatImage(props: { dog?: boolean; SmartAvatarProps: ISmartAvatar }) {
  const { dog, SmartAvatarProps } = props;
  return (
    <Fragment>
      {
        SmartAvatarProps.src && !isPlaceholder(SmartAvatarProps.src)
          ? <SmartAvatar {...SmartAvatarProps} size={11}/>
          : (
            dog
              ? <DogAvatarPlaceholder size={11} disableRipple={true}/>
              : <AvatarPlaceholder size={11} disableRipple={true}/>
          )
      }
    </Fragment>
  );
}

function ChatBubble(props: IChatBubble) {
  const { direction, avatar, body, thumbnail, date, phone, GridProps, dog } = { GridProps: {} as MuiGridProps, ...props };
  return (
    <React.Fragment>
      <Grid
        container
        direction={direction === 'left' ? 'row' : 'row-reverse'}
        wrap="nowrap"
        sx={{
          ...(direction === 'left' ? leftStyles : rightStyles),
          ...(GridProps.sx ? GridProps.sx : {})
        }}
        {...GridProps}
      >
        {avatar && <ChatImage SmartAvatarProps={avatar} dog={dog}/>}
        <Typography
          component="div"
          variant="body1"
          sx={direction === 'left' ? bubble1 : bubble2}
        >
          {body}
        </Typography>
        {thumbnail && <SmartImage
          {...thumbnail}
          style={{
            width: 110,
            marginTop: 6,
            marginLeft: 52,
            borderRadius: 5,
            backgroundColor: '#f9f9f9',
            ...(thumbnail && thumbnail.style ? thumbnail.style : {})
          }}
        />}
      </Grid>
      {
        date &&
        <Typography
          variant="caption"
          style={{ textAlign: 'right', padding: 8 }}>
          {phone ? phone + ' ' : ''}
          {moment(date).format('l, h:mm a')}
        </Typography>
      }
    </React.Fragment>
  );
}

export default memo(ChatBubble);
